import * as React from "react";
import styled from "styled-components";
import * as h from "../../../../ui/_themes/helpers/index";

export interface IDisplayDesktopProps {
  dataE2EId: string;
  className?: string;
  label: string;
  value: string;
  childValue?: string;
  isCash?: boolean;
}

const calculateFontSize = (str: string) => {
  if (!str || str.length <= 11) {
    return "1em";
  } else if (str.length <= 13) {
    return "0.9em";
  } else if (str.length <= 15) {
    return "0.8em";
  } else if (str.length <= 17) {
    return "0.7em";
  } else {
    return "0.6em";
  }
};

const DisplayDesktop: React.FunctionComponent<IDisplayDesktopProps> = props => {
  const showChildValue =
    typeof props.childValue !== "undefined" && !props.isCash;

  return (
    <div className={props.className}>
      <div>
        <span data-e2e-id={`${props.dataE2EId}-label`}>{props.label}</span>
      </div>
      <div>
        <span data-e2e-id={`${props.dataE2EId}-value`}>{props.value}</span>
      </div>
      {showChildValue && (
        <div>
          <span data-e2e-id={`${props.dataE2EId}-secondary-value`}>
            {props.childValue}
          </span>
        </div>
      )}
    </div>
  );
};

export const DisplayDesktopDefault = styled(DisplayDesktop)`
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: inherit;

  color: ${h.getColor("displays")};

  > div:nth-of-type(1) > span {
    font-size: 0.55em;
    font-weight: 400;
    padding: 1em 0 0;
    display: block;
    letter-spacing: 0.1em;

    text-shadow: ${h.getTextShadow("displaysTitle", "displays.title")};
  }

  > div:nth-of-type(2) {
    display: flex;
    align-items: center;
    justify-content: center;

    max-width: 100%;

    color: ${h.getColor("displaysValue", "displays.value")};
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1;
    padding: 0.3em 0 0.2em;

    overflow: hidden;

    > span {
      font-size: ${(props: IDisplayDesktopProps) =>
        calculateFontSize(props.value)};
    }
  }

  > div:nth-of-type(3) {
    font-size: 0.6em;
    letter-spacing: 0.05em;
  }
`;

export const DisplayDesktopMinimal = styled(DisplayDesktop)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  div {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  span {
    padding: 0;
    margin: 0;
    letter-spacing: ${props => (props.isCash ? "0.04em" : "0.1em")};
    line-height: 1;

    color: ${h.getColor("displays")};
  }

  > div:nth-of-type(1) > span {
    font-size: ${props => (props.isCash ? "0.8em" : "0.6em")};
    font-weight: normal;
  }

  > div:nth-of-type(2) {
    margin-left: 0.4em;

    color: ${h.getColor("displaysValue", "displays.value")};

    > span {
      font-size: ${props => (props.isCash ? "0.8em" : "0.6em")};
      font-weight: 700;
    }
  }

  > div:nth-of-type(3) {
    margin-left: 0.5em;

    > span {
      font-size: 0.6em;
      font-weight: normal;
    }
  }
`;
